export default __webpack_public_path__ + "static/media/softwareeng.4d15678a.png";